import React from 'react';

import {
  ClickableComponent,
  FontAwesomeIcon,
  Text,
} from '@schoolinks/ui-components';
import cn from 'classnames';
import { func, bool, shape, element, string } from 'prop-types';

import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';

import useMediaInfo from 'hooks/useMediaInfo';

import s from './Switcher.css';

const Switcher = ({ setAnchor, anchor, isMobile, selectedOption, options }) => {
  const item = options[selectedOption];
  const { isDesktop } = useMediaInfo();

  return (
    <ClickableComponent
      className={cn(s.selectedItem, { [s.mobile]: isMobile })}
      onClick={e => (anchor ? null : setAnchor(e.currentTarget))}
    >
      <div className={s.icon}>{item?.icon}</div>
      <div className={s.selectionDetail}>
        <Text className={s.maxWidthText} color="white" variant="tiny">
          SELECTED MODE
        </Text>
        <Text
          className={s.maxWidthText}
          color="white"
          variant={isDesktop ? 'bodyMd400' : 'bodySm400'}
        >
          {item?.title}
        </Text>
      </div>

      <div className={s.arrow}>
        <FontAwesomeIcon icon={anchor ? faChevronUp : faChevronDown} />
      </div>
    </ClickableComponent>
  );
};

Switcher.propTypes = {
  setAnchor: func.isRequired,
  isMobile: bool.isRequired,
  selectedOption: string.isRequired,
  anchor: element,
  options: shape({}).isRequired,
};

Switcher.defaultProps = {
  anchor: null,
};

export default Switcher;
